// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5f878be2] .el-dialog__body {\n  padding: 10px 10px;\n  height: 400px;\n  overflow: auto;\n}\n[data-v-5f878be2] .el-dialog__body .el-radio {\n  height: 40px;\n  line-height: 40px;\n}\n.el-form-item--mini.el-form-item[data-v-5f878be2] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
